module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Cart#1-d9cf0e10d65905a6cca309b995c94517.svg";